import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App';
import './index.css';

const el = document.getElementById('root');

const root = ReactDOM.createRoot(el);

root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);
